var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars"},_vm._l((_vm.rateArray),function(val,index){return _c('div',{key:index,staticClass:"star"},[_c('i',{staticClass:"icon-star-bordered not-fill"}),_c('i',{staticClass:"icon-star2 fill",style:({width: val})})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }